module.exports = __webpack_public_path__ + "img/google-brands.da3a9ed4.svg";